/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotIdeMetric extends models.CopilotMetricActivityBase {
    getFixupPrototypeFunction() { return CopilotIdeMetric.fixupPrototype; }

    static newInstance(model: Partial<CopilotIdeMetric>): CopilotIdeMetric {
        let obj = Object.assign(new CopilotIdeMetric(), model);
        CopilotIdeMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotIdeMetric>): CopilotIdeMetric {
        if (!model) return null;
        return CopilotIdeMetric.newInstance(<CopilotIdeMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotIdeMetric) {
        if (!obj) return;

        models.CopilotIdeMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotIdeMetric): boolean {
        if (models.CopilotMetricActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotIdeMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * IDE name (e.g. vscode, intellij)
     */
    name: string;

}
